import React, { CSSProperties } from 'react';

import { IMenuItem } from '../../../../interfaces/menu';

import { NavLink, withRouter } from 'react-router-dom';
import className from '../../../../utils/classNames';
import { t } from 'i18next';
import { Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';

interface SimpleItemProps extends IMenuItem {
  color?: string;
  accentColor?: string;
  accentContrast?: string;
}

const SimpleItem: React.FunctionComponent<SimpleItemProps | any> = props => {
  const { icon, title, routing, layout, location, color, accentColor, accentContrast,locked } = props;

  const itemClasses = className({
    'menu-item': true,
    active: location.pathname === `/admin/${routing}`,
    locked: locked
  });

  const style: CSSProperties = {
    color: color,
    opacity: locked ? 0.5 : 1,
    pointerEvents: locked ? 'none' : 'auto',
    cursor: locked ? 'not-allowed' : 'pointer'
  };
  const activeStyle: CSSProperties = {
    color: accentContrast,
    backgroundColor: accentColor,
    opacity: locked ? 0.5 : 1,
    pointerEvents: locked ? 'none' : 'auto',
    cursor: locked ? 'not-allowed' : 'pointer'
  };

  const navigateToPage = () => {
    if (!locked) {
      window.location.replace(`/${layout}/${routing}`);
    }
  };

  return (
    <li className={itemClasses}>
      <Button
        onClick={navigateToPage}
        className="item-link"
        style={location.pathname === `/admin/${routing}` ? activeStyle : style}
        type="link" // Ant Design "link" tipi saydam arka plan için idealdir
        disabled={locked}
      >
        <span
          className={`link-icon ${icon.class}`}
          style={{ backgroundColor: icon.bg, color: icon.color }}
        />
        <span className="link-text">{t(title)}</span>
        {locked && <LockOutlined style={{ marginLeft: 8, color: '#d32f2f' }} />}
      </Button>
    </li>
  );
};

export default withRouter(SimpleItem);
